import { gridByIdSelector } from "../gridByIdSelector";
import { RootState } from "@/store/store";

export const differentResourceTypesSelectedOnOneGrid = (
  state: RootState,
  gridId: string,
) => {
  const grid = gridByIdSelector(state, gridId);

  if (!grid?.selection) {
    return false;
  }

  const selections = Object.values(grid.selection);

  return selections.filter((selection) => !!selection?.length)?.length > 1;
};
